import { Chip, ChipOwnProps } from '@razz-team/ui-web';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function mapServerTransferStatus(status: string): string {
  switch (status) {
    case 'POSTPONED':
      return 'NOT_SENT';
    case 'COMPLETED':
      return 'COMPLETED';
    case 'FAILED':
      return 'FAILED';
    case 'CREATED':
    case 'PENDING':
    case 'APPROVED':
    case 'SUBMITTED':
    case 'SUSPENDED':
    default:
      return 'PENDING';
  }
}

export function TransferState({ status }: { status: string }) {
  const { t } = useTranslation();

  const properties: { text: string; color: ChipOwnProps['color'] } = useMemo(() => {
    const mappedStatus = mapServerTransferStatus(status);
    switch (mappedStatus) {
      case 'NOT_SENT':
        return {
          text: t('Not sent'),
          color: 'tertiary',
        };
      case 'COMPLETED':
        return {
          text: t('Sent'),
          color: 'success',
        };
      case 'FAILED':
        return {
          text: t('Failed'),
          color: 'error',
        };
      case 'PENDING':
      default:
        return {
          text: t('Processing'),
          color: 'purple',
        };
    }
  }, [status, t]);

  return (
    <Chip
      label={properties.text}
      color={properties.color}
      sx={{
        borderRadius: 1,
        fontSize: '12px',
        fontWeight: 500,
        height: 'unset',
        padding: '4px 8px',
        '& .MuiChip-label': {
          padding: 0,
        },
      }}
    />
  );
}
